import React, { forwardRef } from "react";
import { ComboBox } from "@progress/kendo-react-dropdowns";

/**
 * DKNComboBox — Daikin design system searchable/editable dropdown.
 * Wraps Kendo ComboBox.
 *
 * Props:
 *   data        Array
 *   value       any — controlled value
 *   onChange    (e) => void
 *   onFilter    (e) => void — for server-side filtering
 *   textField   string (default: "text")
 *   dataItemKey string (default: "value")
 *   label       string
 *   error       string
 *   placeholder string
 *   fullWidth   boolean (default: false)
 *   loading     boolean — shows loading indicator while fetching
 */
const DKNComboBox = forwardRef(function DKNComboBox(
  {
    data = [],
    value,
    onChange,
    onFilter,
    textField = "text",
    dataItemKey = "value",
    label,
    error,
    placeholder,
    fullWidth = false,
    loading = false,
    disabled = false,
    className = "",
    style,
    ...rest
  },
  ref
) {
  return (
    <div
      className={`dkn-input-wrap${fullWidth ? " dkn-input-full" : ""}${error ? " dkn-input-error" : ""} ${className}`}
      style={style}
    >
      {label && <label className="dkn-input-label">{label}</label>}
      <ComboBox
        ref={ref}
        data={data}
        value={value}
        onChange={onChange}
        onFilterChange={onFilter}
        textField={textField}
        dataItemKey={dataItemKey}
        placeholder={placeholder}
        disabled={disabled}
        loading={loading}
        filterable={!!onFilter}
        className={`dkn-input${error ? " dkn-input-invalid" : ""}`}
        {...rest}
      />
      {error && <span className="dkn-input-helper-text">{error}</span>}
    </div>
  );
});

export default DKNComboBox;
